import React, { useRef, useState } from "react";
import { LuMail } from "react-icons/lu";
import { recoverPassword } from "../../api/login";

export const FormRecover = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  const submitting = useRef(false);
  const handleRecover = async event => {
    event.preventDefault();
    if (submitting.current) return;
    submitting.current = true; setPending(true); setError("");
    try {
      const response = await recoverPassword({ email: email.trim().toLowerCase() });
      if (response?.error !== false) throw new Error("recovery failed");
      setSent(true);
    } catch {
      setError("No se ha podido procesar la solicitud. Inténtalo de nuevo.");
    } finally { submitting.current = false; setPending(false); }
  };
  if (sent) return <p role="status">Si existe una cuenta con ese correo, recibirás instrucciones para recuperar la contraseña. Revisa también la carpeta de spam.</p>;
  return <form onSubmit={handleRecover} aria-label="Recuperar contraseña" aria-busy={pending}>
    <label htmlFor="recover-email" className="labelLogin">Email</label>
    <div className="input-container"><LuMail className="inputLeft" aria-hidden="true" /><input id="recover-email" className="inputSpaceAtStart" type="email" autoComplete="email" required value={email} disabled={pending} onChange={event => setEmail(event.target.value)} /></div>
    {error && <p role="alert">{error}</p>}
    <button className="button-1 mt-2" type="submit" disabled={pending}>{pending ? "Enviando…" : "Enviar instrucciones"}</button>
  </form>;
};
